import React, { useEffect, useState } from "react";
import Aos from "aos";
import ServiceInfo from "../../../components/admin/actions/ServiceInfo";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ServiceAdd from "../../../components/admin/actions/ServiceAdd";
import ServiceEdit from "../../../components/admin/actions/ServiceEdit";
import { delServiceInfo } from "../../../redux/slices/mainDataSlice";

const Services = () => {
  const [serviceInfo, setServiceInfo] = useState(false);
  const [serviceInfoId, setServiceInfoId] = useState("0");
  const [serviceInfoClinc, setServiceInfoClinc] = useState("0");
  const [serviceEdit, setServiceEdit] = useState(false);
  const [serviceAdd, setServiceAdd] = useState(false);
  const data = useSelector((state) => state.main.data?.servicesData);
  const handleShowImages = (id, clinc) => {
    setServiceInfo(true);
    setServiceInfoId(`${id}`);
    setServiceInfoClinc(`${clinc}`);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const navigate = useNavigate();
  const isAuth = useSelector((state) => state.main.isAuthenticated);
  useEffect(() => {
    if (!isAuth) {
      navigate("/login");
    }
  }, [isAuth]);

  const handlerEditService = (id) => {
    setServiceEdit(true);
    setServiceInfoId(`${id}`);
  };
  const dispatch = useDispatch();
  return (
    <>
      <section className="services-admin">
        <div className="background">
          <img src="/images/BGg.png" alt="" />
        </div>
        <div
          className="head-title"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          <span>خدمـــاتـنـــا</span>{" "}
          <div className="add-icon" onClick={() => setServiceAdd(true)}>
            <lord-icon
              src="https://cdn.lordicon.com/jgnvfzqg.json"
              trigger="hover"
              className="img"
              style={{ width: "50px", height: "50px" }}
            ></lord-icon>
          </div>
        </div>
        <div className="services-container">
          <div
            className="service spic"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-delay="600"
          >
            <div className="content">
              <div className="icon">
                <lord-icon
                  src="https://cdn.lordicon.com/lmvawnca.json"
                  trigger="hover"
                  colors="primary:#fff,secondary:#fff"
                  target=".service"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="title">تجميل الوجه لا جراحي</div>
            </div>

            <div className="service-container">
              <div className="service-d">
                <span>شد الوجــه بالخيـــط</span>{" "}
                <div
                  className="icon"
                  onClick={() => handleShowImages("spic1", "1")}
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/pbhjpofq.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service-d"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
              </div>
              <div className="service-d">
                <span>رفــــع الحاجـــب</span>
                <div
                  className="icon"
                  onClick={() => handleShowImages("spic2", "1")}
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/pbhjpofq.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service-d"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
              </div>
              <div className="service-d">
                <span>حقـــن البوتوكـــس</span>
                <div
                  className="icon"
                  onClick={() => handleShowImages("spic3", "1")}
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/pbhjpofq.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service-d"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
              </div>
              <div className="service-d">
                <span>حقــــن الفيـلـــر</span>
                <div
                  className="icon"
                  onClick={() => handleShowImages("spic4", "1")}
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/pbhjpofq.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service-d"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
              </div>
              <div className="service-d">
                <span> ابر نضــــاره والحقــن بالبـلازمــــا</span>
                <div
                  className="icon"
                  onClick={() => handleShowImages("spic5", "1")}
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/pbhjpofq.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service-d"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
              </div>
            </div>
          </div>
          {data?.map((service, index) => (
            <div
              className="service"
              key={service.id}
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-delay={index * 200}
            >
              <div className="content">
                <div className="icon">
                  <lord-icon
                    src="https://cdn.lordicon.com/lmvawnca.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
                <div className="title">{service?.service_card_name}</div>
              </div>
              <div
                className="edit-icon"
                onClick={() => handlerEditService(service?.id)}
              >
                <img src="/images/edit-text.png" alt="" />
              </div>
              <div
                className="del-icon"
                onClick={() => dispatch(delServiceInfo(service?.id))}
              >
                <lord-icon
                  src="https://cdn.lordicon.com/skkahier.json"
                  trigger="hover"
                  className="img"
                  style={{ width: "50px", height: "50px" }}
                ></lord-icon>
              </div>
              <div className="grouping">
                <div className="info">{service?.service_card_info}</div>
                <div
                  className="images"
                  onClick={() =>
                    handleShowImages(service?.id, service?.clinc_id)
                  }
                >
                  <lord-icon
                    src="https://cdn.lordicon.com/pbhjpofq.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".service"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <ServiceAdd serviceAdd={serviceAdd} setServiceAdd={setServiceAdd} />
      <ServiceEdit
        serviceEdit={serviceEdit}
        serviceId={serviceInfoId}
        setServiceEdit={setServiceEdit}
      />
      <ServiceInfo
        serviceInfoId={serviceInfoId}
        serviceInfo={serviceInfo}
        serviceInfoClinc={serviceInfoClinc}
        setServiceInfo={setServiceInfo}
      />
    </>
  );
};

export default Services;
